(() => {
  if (window.__fcpSectionInit) return;
  window.__fcpSectionInit = true;

  const initHoverVideos = (root = document) => {
    const mediaCards = root.querySelectorAll('.featured-collection-pro .fcp-card__media[data-has-hover-video="true"]');
    mediaCards.forEach((card) => {
      if (card.dataset.hoverVideoInit === 'true') return;
      card.dataset.hoverVideoInit = 'true';

      const hoverWrap = card.querySelector('[data-hover-video-wrap]');
      const video = hoverWrap ? hoverWrap.querySelector('[data-hover-video]') : null;
      if (!video) return;

      const playVideo = () => {
        if (video.tagName !== 'VIDEO') return;
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
      };

      const pauseVideo = () => {
        if (video.tagName !== 'VIDEO') return;
        video.pause();
        video.currentTime = 0;
      };

      card.addEventListener('mouseenter', playVideo);
      card.addEventListener('mouseleave', pauseVideo);
      card.addEventListener('focusin', playVideo);
      card.addEventListener('focusout', pauseVideo);
    });
  };

  const initRatingSlots = (root = document) => {
    const ratings = root.querySelectorAll('.featured-collection-pro [data-fcp-rating]');
    ratings.forEach((rating) => {
      if (rating.dataset.ratingInit === 'true') return;
      rating.dataset.ratingInit = 'true';

      const update = () => {
        const hasNodes = rating.children.length > 0;
        const hasText = rating.textContent && rating.textContent.trim().length > 0;
        const hasPluginNode =
          rating.querySelector('.loox-rating') ||
          rating.querySelector('[data-star-rating]') ||
          rating.querySelector('.jdgm-widget') ||
          rating.querySelector('.spr-badge') ||
          rating.querySelector('[data-bv-show]') ||
          rating.querySelector('.bv_main_container');

        if (hasNodes || hasText || hasPluginNode) {
          rating.classList.remove('is-hidden');
        } else {
          rating.classList.add('is-hidden');
        }
      };

      update();
      const observer = new MutationObserver(update);
      observer.observe(rating, { childList: true, subtree: true, characterData: true });
      setTimeout(update, 1200);
      setTimeout(update, 2800);
    });
  };

  const initPanelOverflow = (root = document) => {
    const panels = root.querySelectorAll('.featured-collection-pro .tabs__panel');
    panels.forEach((panel) => {
      if (panel.dataset.fcpOverflowInit === 'true') return;
      panel.dataset.fcpOverflowInit = 'true';

      const rows = panel.querySelector('.featured-collection-pro__rows');
      if (!rows) return;

      const cards = Array.from(rows.querySelectorAll('.fcp-card'));
      const totalItems = cards.length;
      if (totalItems === 0) return;

      const configuredPerPage = parseInt(panel.dataset.itemsPerPage || '0', 10);
      const itemsPerPage = Number.isFinite(configuredPerPage) && configuredPerPage > 0 ? configuredPerPage : totalItems;
      const enableViewMore = panel.dataset.enableViewMore === 'true';
      const enableCollapse = panel.dataset.enableCollapse !== 'false';
      const viewMoreLabel = panel.dataset.viewMoreLabel || 'View more';
      const collapseLabel = panel.dataset.collapseLabel || 'Collapse';

      const controls = panel.querySelector('[data-fcp-controls]');
      const viewMoreBtn = controls ? controls.querySelector('[data-fcp-view-more]') : null;

      let expanded = false;
      if (viewMoreBtn) {
        viewMoreBtn.textContent = viewMoreLabel;
        viewMoreBtn.setAttribute('aria-expanded', 'false');
      }

      const render = () => {
        cards.forEach((card, index) => {
          let isVisible = expanded || index < itemsPerPage;
          card.hidden = !isVisible;
        });

        if (!controls) return;

        const hasOverflow = totalItems > itemsPerPage;
        const showToggle = hasOverflow && enableViewMore && (!expanded || enableCollapse);
        if (viewMoreBtn) {
          viewMoreBtn.hidden = !showToggle;
          viewMoreBtn.textContent = expanded ? collapseLabel : viewMoreLabel;
          viewMoreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        }
        controls.hidden = !showToggle;
      };

      if (viewMoreBtn) {
        viewMoreBtn.addEventListener('click', () => {
          if (!expanded) {
            expanded = true;
          } else if (enableCollapse) {
            expanded = false;
          }
          render();
        });
      }

      render();
    });
  };

  const initAll = (root = document) => {
    initHoverVideos(root);
    initRatingSlots(root);
    initPanelOverflow(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target || document);
  });
})();
